module.exports = __webpack_public_path__ + "img/cosq2.2177d825.png";